import { render } from "./ImageViewerMobile.vue?vue&type=template&id=2159cd8c&scoped=true&ts=true"
import script from "./ImageViewerMobile.vue?vue&type=script&lang=ts"
export * from "./ImageViewerMobile.vue?vue&type=script&lang=ts"

import "./ImageViewerMobile.vue?vue&type=style&index=0&id=2159cd8c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2159cd8c"]])

export default __exports__